import { FormItem } from '../../../../commons/Form/Form.types';
import { ForgotPasswordFormSchema } from './ForgotPasswordForm.types';

export const registerSignUpStepData: FormItem<ForgotPasswordFormSchema>[][] = [
  [
    {
      name: 'email',
      placeholder: 'Votre adresse email...',
      label: 'Adresse email',
      type: 'text',
      required: true,
    },
  ],
];
